import { h } from 'preact';
import React, { Component } from 'react';
import LinkSVG from './Link.svg';
import { makeText } from '../../../util';

const Tag = ({ vendor }) => (
  <a tabIndex="-1" href={vendor.policyUrl} target="_blank" className="vendor-tag linked">
    <span>{vendor.name}</span>
    <img src={LinkSVG} alt="" />
  </a>
);

export default class Toggle extends Component {
  state = {
    open: false
  }
  toggleAccordion = e => {
    const content = this.content;
    const open = !this.state.open;
    this.setState({ open }, this.props.force);
    if (!open) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }
  openLink = () => window.open(this.props.vendor.policyUrl, '_blank');
  render() {
    const { vendor, settings, language, dev, accordionOpen, isSpecialPurpose } = this.props;
    const { open } = this.state;
    const cookieCount = vendor.cookies ? vendor.cookies.length : 0;

    const cookies = vendor.cookies || [];

    const cookieText = makeText(Boolean(dev), settings, 'cookieText', language);
    const tableCookieText = makeText(Boolean(dev), settings, 'tableCookieText', language);
    const tableDomainText = makeText(Boolean(dev), settings, 'tableDomainText', language);
    const tableDurationText = makeText(Boolean(dev), settings, 'tableDurationText', language);
    const otherLetter = makeText(Boolean(dev), settings, 'otherLetter', language);
    return (
      <div className="toggle-vendor">
        <div style={{ position: 'relative' }}>
          <button
            tabIndex={accordionOpen || accordionOpen === undefined ? 0 : -1}
            className={open ? 'expand active' : 'expand'}
            onClick={cookieCount > 0 ? this.toggleAccordion : this.openLink}
          >
            {cookieCount > 0 ? <span className="plusminus">{open ? '-' : '+'}</span> : <img src={LinkSVG} alt="" />}
            <span style={{ padding: '0 5px' }}>
              {vendor.name}
            </span>
            {(vendor.vendorType !== 'IAB' && !isSpecialPurpose) && (
              <span className="legend-key">
                {otherLetter}
              </span>
            )}
            {cookieCount > 0 ? <span style={{ marginLeft: '5px' }}>({cookieCount} {cookieText})</span> : null}
          </button>
        </div>
        <div ref={c => this.content = c} className="content">
          <div className="inner-content">
            <Tag vendor={vendor} />
            <table className="tvtbl">
              <tr><th>{tableCookieText}</th><th>{tableDomainText}</th><th>{tableDurationText}</th></tr>
              {cookies.map((c) => (
                <tr>
                  <td><span>{c.name}</span></td>
                  <td><a href={c.domain}>{c.domain}</a></td>
                  <td><span>{c.cookieLifeSpan}</span></td>
                </tr>
              ))}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

